<div class="contract-container">

  <!-- Header Principal -->
  <div class="contract-header">
    <div class="header-content">
      <div class="header-left">
        <i class="fa-solid fa-file-contract"></i>
        <div class="header-text">
          <h1>Contrato del Arrendamiento</h1>
          <p class="header-subtitle">Datos y documentos del contrato</p>
        </div>
      </div>
      <div class="header-right">
        <p-tag *ngIf="data?.contract?.contractNumber"
               [value]="'N° ' + data?.contract?.contractNumber"
               severity="success"
               icon="pi pi-hashtag"></p-tag>
        <p-tag *ngIf="!data?.contract?.contractNumber"
               value="Sin número de contrato"
               severity="warning"
               icon="pi pi-info-circle"></p-tag>
      </div>
    </div>
  </div>

  <!-- Card unificada: datos + documentos del contrato -->
  <div class="info-card">
    <div class="card-header">
      <i class="fa-solid fa-file-contract text-blue-600"></i>
      <h3>Datos y documentos del contrato</h3>
    </div>
    <div class="card-content">

      <!-- Número de contrato -->
      <form [formGroup]="contractForm" *appIfHasPermission="['leases','update']" class="contract-number-block">
        <div class="field contract-number-field">
          <label for="contractNumber">Número de contrato</label>
          <div class="p-inputgroup">
            <input
              id="contractNumber"
              type="text"
              pInputText
              formControlName="contractNumber"
              placeholder="Ej. CTR-2026-00123"
              maxlength="60" />
            <button
              pButton
              type="button"
              icon="pi pi-check"
              label="Guardar"
              class="p-button-success"
              (click)="saveContractNumber()"
              [loading]="savingNumber"
              [disabled]="savingNumber"></button>
          </div>
          <small class="field-hint">Identificador del contrato físico/legal del arrendamiento.</small>
        </div>
      </form>

      <!-- Tasa moratoria: otro permiso que el número de contrato, motivo obligatorio y queda en Bitácora -->
      <form [formGroup]="rateForm" *appIfHasPermission="['leases','edit-amounts']" class="contract-number-block">
        <div class="field contract-number-field">
          <label for="moratoryRate">Tasa moratoria mensual (%)</label>
          <div class="p-inputgroup">
            <p-inputNumber inputId="moratoryRate" formControlName="ratePercent" mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="2" suffix=" %" [min]="0" [max]="20"></p-inputNumber>
            <button pButton type="button" icon="pi pi-check" label="Guardar" class="p-button-success" (click)="saveMoratoryRate()" [loading]="savingRate" [disabled]="savingRate || rateForm.invalid"></button>
          </div>
          <label for="rateReason" class="mt-2">Motivo del cambio (obligatorio)</label>
          <textarea id="rateReason" pInputTextarea formControlName="reason" rows="2" [maxlength]="500" placeholder="Queda en la Bitácora junto con la tasa anterior y la nueva."></textarea>
          <small class="field-hint" *ngIf="data?.moratoryRate; else sinTasaPropia">Vigente: {{ data?.moratoryRate | percent:'1.1-2' }} · aplica a las aplicaciones siguientes; no recalcula la mora ya materializada.</small>
          <ng-template #sinTasaPropia>
            <!-- Un arrendamiento anterior a Exigibilidad no tiene tasa sellada. Decir «0.0 %» afirmaba que
                 no cobra mora, y sí la cobra: cae en la tasa por omisión de las Reglas de cartera. -->
            <small class="field-hint">Sin tasa propia: mientras no se guarde una, se usa la <strong>tasa por omisión</strong> de Cartera › Configuración › Reglas. Al guardarla aplica a las aplicaciones siguientes; no recalcula la mora ya materializada.</small>
          </ng-template>
        </div>
      </form>

      <!-- Separador de sección -->
      <div class="section-divider">
        <i class="pi pi-shield"></i>
        <span>Documentos (garantía)</span>
      </div>

      <!-- Documentos: cada sección admite N archivos -->
      <div class="docs-grid">
        <app-input-multi-file
          label="Aprobación de contrato"
          (filesChanged)="onDocsChanged('contractAppoval', $event)"
          (downloadRequested)="onDownloadRequested($event, 'aprobacion_contrato')"
          [tooltip]="'Documentos de aprobación del contrato de arrendamiento'"
          [documentName]="'contractApproval'"
          [folder]="'contract'"
          [id]="leaseDetailService.id"
          [fileUrlValues]="toArray(data?.contract?.contractAppoval)">
        </app-input-multi-file>

        <app-input-multi-file
          label="Aprobación de pagaré"
          (filesChanged)="onDocsChanged('promissoryApproval', $event)"
          (downloadRequested)="onDownloadRequested($event, 'aprobacion_pagare')"
          [tooltip]="'Documentos de aprobación del pagaré'"
          [documentName]="'promissoryNoteApproval'"
          [folder]="'contract'"
          [id]="leaseDetailService.id"
          [fileUrlValues]="toArray(data?.contract?.promissoryApproval)">
        </app-input-multi-file>

        <app-input-multi-file
          label="Factura de compra"
          (filesChanged)="onDocsChanged('invoice', $event)"
          (downloadRequested)="onDownloadRequested($event, 'factura_compra')"
          [tooltip]="'Facturas de compra del activo'"
          [documentName]="'purchaseInvoice'"
          [folder]="'contract'"
          [id]="leaseDetailService.id"
          [fileUrlValues]="toArray(data?.contract?.invoice)">
        </app-input-multi-file>
      </div>

    </div>
  </div>

</div>

